import React, { useEffect, useState } from "react";
import { searchProducts } from "../services/nonAuthRequets";
import ProductCards from "./ProductCards";
import { useSearchParams } from "react-router-dom";
import PaginateComponent from "./PaginateComponent";
import LoadingComponent from "./LoadingComponent";
import NoResultsComponent from "./NoResultsComponent";
const ProductListOne = ({ pageSize, showLoadMore = true }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("query");

  const fetchProducts = async (query = "", page = 0) => {
    setLoading(true);
    try {
      const data = await searchProducts(query, page, pageSize);
      setTotalPages(data.totalPages);
      if (showLoadMore) {
        setProducts((prevProducts) => {
          const updatedProducts = [...prevProducts, ...data.content];
          // Deduplicate products by their id
          return Array.from(new Map(updatedProducts.map((p) => [p.id, p])).values());
        });
      } else {
        setProducts(data.content);
      }
    } catch (error) {
      console.error("Error searching products:", error);
    } finally {
      setLoading(false);
    }
  };

  // Combine searchQuery and currentPage changes into one effect.
  useEffect(() => {
    // If it's a new search query (i.e., page is 0), clear previous products.
    if (currentPage === 0) {
      setProducts([]);
    }
    fetchProducts(searchQuery || "", currentPage);
  }, [searchQuery, currentPage, pageSize, showLoadMore]);

  // const loadMoreProducts = () => {
  //   const nextPage = currentPage + 1;
  //   if (nextPage < totalPages) {
  //     setCurrentPage(nextPage);
  //     // No need to call fetchProducts here because the effect will handle it.
  //   }
  // };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <LoadingComponent message="Loading products..." />;
  }
  if (products.length === 0) {
    return <NoResultsComponent message="No products found" />;
  }

  return (
    <>
      <ProductCards
        products={products}
        currentPage={currentPage}
        totalPages={totalPages}
        //loadMoreProducts={loadMoreProducts}
        showLoadmore={showLoadMore}
      />
      {!showLoadMore && (
        <PaginateComponent
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageClick={handlePageClick}
        />
      )}
    </>
  );
};

export default ProductListOne;
